<app-loader-indicator></app-loader-indicator>
<div class="full-page-container">
  <div class="congratulation-box">
    <div class="text-box">
      <mat-icon>warning</mat-icon><span class="margin-left-10">You have been logged out of the college.
      <br>
      <br>
      Please re-login if you need to regain access to your courses.</span>
    </div>
  </div>
</div>
